import { Dispatch, SetStateAction, ReactElement, createContext } from 'react';
import { LoaderProps } from '@/types';

export type PopupContext = {
  setPopupLoader: Dispatch<SetStateAction<ReactElement | undefined>>;

  showLoader: (type?: LoaderProps) => void;
  hideLoader: () => void;

  drawerMenuOpen: boolean;
};

export const ctxPopup = createContext<PopupContext | undefined>(undefined);
